let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("BEB1L")).then(() => parcelRequire('f45ZV'));